import React from 'react';

import formatNumberWithCurrency from '@eika-infrastruktur/format/dist/formatNumberWithCurrency';
import { ProgressBar } from '@eika/progress-bar';
import { DarkSkeleton } from '@eika/skeleton';

import LoanAmount from '../../../components/LoanAmount/LoanAmount';

interface Props {
    interimAmount: number;
    initialAmount: number;
    currency: string;
    isLoading: boolean;
    newAccount?: boolean;
}

const LoanAccountBalance: React.FC<Props> = ({
    interimAmount,
    initialAmount,
    currency,
    isLoading,
    newAccount = false,
}) => {
    if (newAccount) return <></>;

    return (
        <LoanAmount>
            <ProgressBar
                className="loan-account__progress-bar"
                value={interimAmount}
                max={initialAmount}
                labelSkeleton={<DarkSkeleton width={200} height={40} />}
                isLoading={isLoading}
                label={
                    <span itemProp="value" {...{ content: String(interimAmount) }}>
                        {formatNumberWithCurrency(interimAmount, currency, 0)}
                    </span>
                }
            />
        </LoanAmount>
    );
};

export default LoanAccountBalance;
